import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { SubSubGroupTypeDto } from '@cradua/data';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-subsubgrouptype',
  templateUrl: './subsubgrouptype.component.html',
  styleUrls: ['./subsubgrouptype.component.scss'],
})
export class SubsubgrouptypeComponent implements OnChanges {
  subsubgrouptypeForm: FormGroup;
  subsubgrouptypeFormArray: FormGroup;
  control = new FormControl();
  @Input() subsubgrouptypes: SubSubGroupTypeDto[];
  @Input() routeAnimationsElements: any;
  @Output() subsubgrouptype = new EventEmitter<SubSubGroupTypeDto[]>();
  @Output() deleteSubSubGroupTypeEvent = new EventEmitter<any>();

  selectedSubSubGroupType: any;
  filteredDelete: Array<any> = [];
  loading = true;
  selectedIndex = null;
  constructor(private fb: FormBuilder) {}

  ngOnChanges() {
    this.createSubSubGroupTypeForm();
  }

  createSubSubGroupTypeForm() {
    this.subsubgrouptypeForm = this.fb.group({
      SubSubGroupTypeName: ['', Validators.required],
      id: null,
    });
    this.subsubgrouptypeFormArray = this.fb.group({
      SubSubGroupTypes: this.fb.array([]),
    });
    this.setSubSubGroupType();
  }

  // method to display subsubgrouptypes
  setSubSubGroupType() {
    const control = this.subsubgrouptypeFormArray.controls
      .SubSubGroupTypes as FormArray;
    this.subsubgrouptypes.forEach((e) => {
      control.push(
        this.fb.group({
          SubSubGroupTypeName: e.SubSubGroupTypeName,
          id: e.id,
        })
      );
    });
  }

  // method to add SubSubGroupType
  addSubSubGroupType(value: SubSubGroupTypeDto) {
    const control = this.subsubgrouptypeFormArray.controls
      .SubSubGroupTypes as FormArray;
    control.insert(
      0,
      this.fb.group({
        SubSubGroupTypeName: value.SubSubGroupTypeName,
        id: null,
      })
    );
  }

  selectSubSubGroupType(value) {}

  // method to delete subsubgrouptype from arrary list
  deleteSubSubGroupType(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.subsubgrouptypeFormArray.controls
          .SubSubGroupTypes as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.subsubgrouptypes.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.subsubgrouptypes[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  addNew(formValue: SubSubGroupTypeDto) {
    if (this.subsubgrouptypeForm.invalid) {
      return Swal.fire(
        'Warning!',
        'Please, you cannot add blank field',
        'warning'
      );
    }
    if (this.selectedIndex != null) {
      this.subsubgrouptypeFormArray
        .get('SubSubGroupTypes')
        ['controls'][this.selectedIndex].patchValue({
          SubSubGroupTypeName: formValue.SubSubGroupTypeName,
        });
    } else {
      this.addSubSubGroupType(formValue);
    }
    this.selectedIndex = null;
    this.subsubgrouptypeForm.reset();
  }

  onEdit(index, value: SubSubGroupTypeDto) {
    console.log(index, value);
    this.selectedIndex = index;
    this.subsubgrouptypeForm.patchValue({
      SubSubGroupTypeName: value.SubSubGroupTypeName,
    });
  }

  onClearForm() {
    this.selectedIndex = null;
    this.subsubgrouptypeForm.reset();
  }

  onSubmit(formValue: SubSubGroupTypeDto[]) {
    this.subsubgrouptype.emit(formValue);
    if (this.filteredDelete.length !== 0) {
      this.deleteSubSubGroupTypeEvent.emit(this.filteredDelete);
    }
  }
}
